import { useState } from "react";
import { BACKEND_URL } from "@/lib/api";
import { Facebook, Linkedin, MessageCircle, Link2, Check } from "lucide-react";
import { toast } from "sonner";

export default function ShareButtons({ slug, title }) {
  const [copied, setCopied] = useState(false);
  // Crawler-friendly URL: /api/share/video/:slug serves per-video OG tags then redirects humans.
  const shareUrl = `${BACKEND_URL}/api/share/video/${slug}`;
  const text = encodeURIComponent(`${title} — VytaliFlix`);
  const u = encodeURIComponent(shareUrl);

  const links = [
    { key: "facebook", icon: Facebook, label: "Facebook", href: `https://www.facebook.com/sharer/sharer.php?u=${u}` },
    { key: "whatsapp", icon: MessageCircle, label: "WhatsApp", href: `https://wa.me/?text=${text}%20${u}` },
    { key: "linkedin", icon: Linkedin, label: "LinkedIn", href: `https://www.linkedin.com/sharing/share-offsite/?url=${u}` },
  ];

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(shareUrl);
      setCopied(true);
      toast.success("Lien copié");
      setTimeout(() => setCopied(false), 2000);
    } catch (_) {
      toast.error("Impossible de copier");
    }
  };

  return (
    <div className="flex flex-wrap items-center gap-2" data-testid="share-buttons">
      <span className="text-xs uppercase tracking-widest text-muted-foreground">Partager</span>
      {links.map((l) => (
        <a key={l.key} href={l.href} target="_blank" rel="noopener noreferrer" data-testid={`share-${l.key}`}
          className="flex h-9 w-9 items-center justify-center rounded-full border border-white/10 bg-white/5 text-muted-foreground transition-colors hover:border-primary/40 hover:text-primary">
          <l.icon className="h-4 w-4" />
        </a>
      ))}
      <button onClick={copy} data-testid="share-copy"
        className="flex h-9 w-9 items-center justify-center rounded-full border border-white/10 bg-white/5 text-muted-foreground transition-colors hover:border-primary/40 hover:text-primary">
        {copied ? <Check className="h-4 w-4 text-primary" /> : <Link2 className="h-4 w-4" />}
      </button>
    </div>
  );
}
